<template>
	<v-layout class="form-perfil" wrap>
		<v-flex xs12 mb-4 v-if="isAdmin && !isEdit">
			<app-button
				:style="`background-color: ${$appColors.success};`"
				class="btn-edit"
				text="Editar"
				@click="goToEdit"
			/>
		</v-flex>
		<v-flex xs6 px-3 mb-3>
			<label
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Nombre
			</label>
			<v-text-field
				label="Nombre"
				solo
				hide-details
				class="input-text"
				:readonly="!isEdit"
				v-model="userData.name"
			></v-text-field>
			<span class="form-group__message"
				v-if="$v.userData.name.$invalid">
				El nombre es requerida
			</span>
		</v-flex>
		<v-flex xs6 px-3 mb-3>
			<label
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Apellido
			</label>
			<v-text-field
				label="Apellido"
				solo
				hide-details
				class="input-text"
				:readonly="!isEdit"
				v-model="userData.lastName"
			></v-text-field>
			<span class="form-group__message"
				v-if="$v.userData.lastName.$invalid">
				El apellido es requerido
			</span>
		</v-flex>
		<v-flex xs6 px-3 mb-3 v-if="user.flagAdmin === '0'">
			<label
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Puesto
			</label>
			<v-text-field
				v-if="isAdmin"
				label="Puesto"
				solo
				hide-details
				class="input-text"
				readonly
				v-model="userData.groupName"
			></v-text-field>
			<v-select
				v-else
				class="select-core"
				outline
				single-line
				readonly
				:height="33"
				hide-details
				item-text="name"
				item-value="id"
				label="Puesto"
				:menu-props="{ contentClass: 'type-select-content' }"
				:items="groups"
				v-model="userData.groupId"
			></v-select>
		</v-flex>
		<v-flex xs6 px-3 mb-3>
			<label
				class="name"
				:style="`color: ${$appColors.secondary};`"
			>
				Tipo de Documento
			</label>
			<v-select
				class="select-core"
				outline
				single-line
				:height="33"
				hide-details
				:readonly="!isEdit"
				item-text="name"
				item-value="id"
				label="Tipo de Documento"
				:menu-props="{ contentClass: 'type-select-content' }"
				:items="typeDocuments"
				v-model="userData.typeDocument"
				@input="setData($event)"
			></v-select>
			<span class="form-group__message"
				v-if="$v.userData.typeDocument.$invalid && this.isEdit">
				El tipo de documento es requerido
			</span>
		</v-flex>
		<v-flex xs6 px-3 mb-3>
			<label
				class="name"
				:style="`color: ${$appColors.secondary};`"># Documento</label>
			<v-text-field
				label="# Documento"
				solo
				hide-details
				class="input-text"
				type="number"
				v-model="userData.documentNumber"
				:readonly="!isEdit"
			></v-text-field>
			<span class="form-group__message"
				v-if="!$v.userData.documentNumber.minLength
				|| !$v.model.documentNumber.maxLength">
				{{ documentMessage }}
			</span>
			<span class="form-group__message"
				v-if="$v.userData.documentNumber.$invalid && this.isEdit">
				El # documento es requerido
			</span>
		</v-flex>
		<v-flex xs6 px-3 class="mb-50">
			<label
				class="name"
				:style="`color: ${$appColors.secondary};`">
				Correo
			</label>
			<v-text-field
				label="Correo"
				solo
				hide-details
				class="input-text"
				v-model="userData.email"
				:readonly="!isEdit"
			></v-text-field>
			<span class="form-group__message"
				v-if="!$v.userData.email.required">
				El email es requerido
			</span>
			<span class="form-group__message"
				v-if="!$v.userData.email.email">
				El email debe ser válido
			</span>
		</v-flex>
		<v-flex xs12 v-if="isEdit" mt-5>
			<v-layout justify-center>
				<v-flex xs3>
					<app-button
						class="btn-form btn-red"
						:style="`background-color: ${$appColors.error};`"
						text="Cerrar"
						@click="goToUser"
					/>
				</v-flex>
				<v-flex xs3>
					<app-button
						:disabled="this.$v.userData.$invalid"
						class="btn-form btn-green"
						:style="`background-color: ${$appColors.success};`"
						text="Guardar"
						@click="editUser"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
import appButton from '@/components/shared/app-button';
import { mapState } from 'vuex';
import { required, email, maxLength, minLength } from 'vuelidate/lib/validators';
import helper from '@/shared/helper';

function created() {
	this.loadData();
	this.idEmployee = this.user.id;
	this.userData = {
		email: this.user.email || '',
		name: this.user.name || '',
		lastName: this.user.lastName || '',
		documentNumber: this.user.documentNumber || null,
		typeDocument: this.user.typeDocument || null,
		groupId: this.user.groupId || null,
		groupName: this.user.groupName || null,
		urlImage: this.user.urlImage || null,
		gender: this.user.gender || null,
	};
}

function goToEdit() {
	this.goTo('profile-edit');
}

async function loadData() {
	const request = [
		this.$httpPraktiko.get('groups'),
		this.$httpPraktiko.get('type-documents'),
	];
	try {
		[{ data: this.groups }, { data: this.typeDocuments }] = await Promise.all(request);
	} catch (error) {
		this.showGenericError();
	}
}

function setData(value) {
	this.personType = this.typeDocuments.find(p => p.id === value) || {};
}

function personType(value) {
	this.personValidations = value && value.configuration ? value.configuration.validations :
		value.configuration;
	if (this.personValidations) {
		this.maxDocument = this.personValidations.maxLength || 0;
		this.minDocument = this.personValidations.minLength || 0;
		if (this.maxDocument && this.minDocument) {
			if (this.maxDocument === this.minDocument) {
				this.documentMessage = `Es necesario ingresar ${this.minDocument} dígitos`;
			} else {
				this.documentMessage = `Es necesario ingresar entre ${this.minDocument} y ${this.maxDocument} dígitos`;
			}
		} else if (this.minDocument) {
			this.documentMessage = `Ingrese un mínimo de ${this.minDocument} dígitos`;
		} else if (this.maxDocument) {
			this.documentMessage = `Ingrese un máximo de ${this.maxDocument} dígitos`;
		} else {
			this.documentMessage = '';
		}
	} else {
		this.documentMessage = '';
	}
}

function validations() {
	const documentValidations = { required };
	if (this.personValidations) {
		if (this.personValidations.maxLength) {
			documentValidations.maxLength = maxLength(this.maxDocument);
		}
		if (this.personValidations.minLength) {
			documentValidations.minLength = minLength(this.minDocument);
		}
	}
	return {
		userData: {
			documentNumber: documentValidations,
			email: { email, required },
			name: { required },
			lastName: { required },
			typeDocument: { required },
		},
	};
}

function goToUser() {
	this.goTo('profile');
}

async function editUser() {
	const body = { ...this.userData };
	body.flagCompany = true;
	delete body.groupName;
	try {
		await this.$httpPraktiko.patch(`employee/${this.idEmployee}`, body);
		this.getUser();
		this.showNotification('La información se actualizó correctamente.');
	} catch (error) {
		this.showGenericError();
	}
}

function imageUser(value) {
	this.userData.urlImage = value;
	this.editUser();
}

async function getUser() {
	const { data: response } = await this.$httpPraktiko.get('employee/current');
	helper.setLocalData('praktiko-user', response);
	helper.setLocalData('acl-code', response.aclCode);
	this.$store.dispatch('setUser', response);
}

function data() {
	return {
		userData: {
			email: '',
			name: '',
			lastName: '',
			documentNumber: null,
			typeDocument: null,
			groupId: null,
			groupName: '',
			urlImage: null,
			gender: null,
		},
		groups: [],
		typeDocuments: [],
		personType: {},
		personValidations: null,
		maxDocument: 0,
		minDocument: 0,
		documentMessage: '',
		idEmployee: null,
	};
}

export default {
	name: 'form-perfil',
	components: {
		appButton,
	},
	created,
	computed: {
		...mapState({
			user: state => state.user,
		}),
	},
	data,
	methods: {
		goToEdit,
		loadData,
		setData,
		goToUser,
		editUser,
		getUser,
	},
	props: {
		isEdit: {
			type: Boolean,
			default: false,
		},
		imageUser: [String],
	},
	validations,
	watch: {
		personType,
		imageUser,
	},
};
</script>
<style lang="scss" scoped>
	.form-perfil {
		align-content: flex-start;
		align-items: flex-start;
		background: color(white);
		border: 1px solid color(gray);
		border-radius: 4px;
		height: 100%;
		padding: 48px;
	}

	.btn-edit {
		background: color(success);
		border-radius: 4px;
		color: color(white);
		font-weight: 600;
		justify-content: center !important;
		padding: 5px 0;
		width: 73px;
	}

	.name {
		color: map-get($colors, secondary);
		font-size: 11px;
	}

	.btn-form {
		border-radius: 4px;
		color: color(white);
		justify-content: center !important;
		padding: 6px 0;
		width: 96px;
	}

	.btn-red {
		background: color(error);
	}

	.btn-green {
		background: color(success);
	}
</style>



// WEBPACK FOOTER //
// src/components/user/form-perfil.vue